import React from "react";
import logo from "../assets/logo.png"; // Correct import path
import "./Header.css"; // Optional for custom styling
import "../styles/main.css"; // Optional for custom styling

function Header() {
  return (
    <header className="container-fluid py-2 header-bg">
      <div className="container">
        <div className="row align-items-center">
          {/* Logo */}
          <div className="col-12 col-md-3 text-center text-md-start mb-2 mb-md-0">
            <img href="/" src={logo} alt="Logo" className="header-logo" />
          </div>

          {/* Menu */}
          <div className="col-12 col-md-9">
            <nav className="nav-menu d-flex justify-content-center justify-content-md-end">
              <a href="/" className="nav-link">Home</a>
              <a href="#services" className="nav-link">Services</a>
              <a href="#about" className="nav-link">About Us</a>
              <a href="#contact" className="nav-link">Contact Us</a>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;